import Vue from 'vue'
import Router from 'vue-router'
import { getSyncToken } from '@/api/util'
import { isLogin } from '@/util/index'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: resolve => require(['@/pages/Home'], resolve),
    //   meta: {
    //   	title: '营客通合伙人',
    //   	auth: false,
    //     keepAlive: false
    //   }
    // },
    { // 新合伙人首页  。
      path: '/',
      name: 'home',
      redirect: '/homeV2',
      component: resolve => require(['@/pages/newHome/index'], resolve),
      meta: {
        title: '营客通合伙人',
        auth: false,
        keepAlive: false
      }
    },
    {
      path: '/oldHome',
      name: 'oldHome',
      component: resolve => require(['@/pages/newHome/indexCopy'], resolve),
      meta: {
        title: '营客通合伙人',
        auth: false,
        keepAlive: false
      }
    },
    {
      path: '/homeV2',
      name: 'homeV2',
      component: resolve => require(['@/pages/homeV2/index'], resolve),
      meta: { title: '首页', auth: false, keepAlive: true, active: 2 },
      redirect: '/homeV2/workSchedule',
      children: [
        {
          path: 'workSchedule',
          name: 'workSchedule',
          component: resolve => require(['@/pages/homeV2/workSchedule'], resolve),
          meta: { title: '待办事项', auth: true, keepAlive: true },
        },
        {
          path: 'merchantCenter',
          name: 'merchantCenter',
          // component: resolve => require(['@/pages/newHome/merchantCenter'], resolve),
          component: resolve => require(['@/pages/newHome/merchantCenterV1'], resolve), // 2025-12-30使用
          meta: {
            title: '驾驶舱',
            auth: true,
            keepAlive: true
          }
        },
        {
          path: 'dataList',
          name: 'merchantDataList',
          component: resolve => require(['@/pages/newHome/dataList'], resolve),
          meta: {
            title: '数据列表',
            auth: true,
            keepAlive: false
          }
        },
        {
          path: 'merchantList',
          name: 'merchantList',
          component: resolve => require(['@/pages/newHome/merchantList'], resolve),
          meta: {
            title: '商户',
            auth: true,
            keepAlive: false
          }
        },
        {
          path: 'increaseRevenue',
          name: 'increaseRevenue',
          component: resolve => require(['@/pages/increaseRevenue/index'], resolve),
          meta: {
            title: '提升收入',
            auth: true,
            keepAlive: false
          }
        },
        {
          path: 'dataCenter',
          name: 'dataCenter',
          component: resolve => require(['@/pages/dataCenter/indexV2'], resolve),
          meta: {
            title: '数据详情',
            auth: true,
            keepAlive: true
          }
        },
        {
          path: '/dataDetail',
          name: 'dataDetail',
          component: resolve => require(['@/pages/dataDetail/index'], resolve),
          meta: {
            title: '数据详情',
            auth: true,
            keepAlive: true
          }
        },
        {
          path: 'bonus',
          name: 'userCenterBonus',
          component: resolve => require(['@/pages/userCenter/bonus'], resolve),
          meta: {
            title: '奖金',
            auth: true
          }
        },
      ]
    },
    {
      path: '/accumulatedMerchant',
      name: 'accumulatedMerchant',
      component: resolve => require(['@/pages/newHome/accumulatedMerchant'], resolve),
      meta: {
        title: '下单合伙人累计商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/partnerPullnew',
      name: 'partnerPullnew',
      component: resolve => require(['@/pages/newHome/partnerPullnew'], resolve),
      meta: {
        title: '下单合伙人拉新商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/updateMark',
      name: 'updateMark',
      component: resolve => require(['@/pages/homeV2/updateMark'], resolve),
      meta: {
        title: '更新标签',
        auth: true,
        keepAlive: false
      },
    },
    {
      path: '/hiddenAdmin',
      name: 'hiddenAdmin',
      redirect: '/',
      component: resolve => require(['@/pages/admin'], resolve),
      meta: {
        title: '数据中心',
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/paidMerchant',
      name: 'paidMerchant',
      component: resolve => require(['@/pages/newHome/paidMerchant'], resolve),
      meta: {
        title: '已缴费商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/unpaidMerchant',
      name: 'unpaidMerchant',
      component: resolve => require(['@/pages/newHome/unpaidMerchant'], resolve),
      meta: {
        title: '注册未缴费商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/freeMerchant',
      name: 'freeMerchant',
      component: resolve => require(['@/pages/newHome/freeMerchant'], resolve),
      meta: {
        title: '体验会员',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/userCenter/invoicing',
      name: 'invoicing',
      component: resolve => require(['@/pages/userCenter/invoicing'], resolve),
      meta: {
        title: '开票',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/userCenter/submitInvoice',
      name: 'submitInvoice',
      component: resolve => require(['@/pages/userCenter/submitInvoice'], resolve),
      meta: {
        title: '提交发票信息',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/userCenter/submitRecord',
      name: 'submitRecord',
      component: resolve => require(['@/pages/userCenter/submitRecord'], resolve),
      meta: {
        title: '提交记录',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/orderUser',
      name: 'adminOrderUser',
      component: resolve => require(['@/pages/admin/orderUser'], resolve),
      meta: {
        title: '下单商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/orderPay',
      name: 'adminOrderPay',
      component: resolve => require(['@/pages/admin/orderPay'], resolve),
      meta: {
        title: '今日已付款订单',
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/admin/saleDataList',
      name: 'adminSaleDataList',
      component: resolve => require(['@/pages/admin/saleDataList'], resolve),
      meta: {
        title: '销售额数据',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/saleDataList2',
      name: 'adminSaleDataList2',
      component: resolve => require(['@/pages/admin/saleDataList2'], resolve),
      meta: {
        title: '销售额数据',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/serveDistribute',
      name: 'adminServeDistribute',
      component: resolve => require(['@/pages/admin/serveDistribute'], resolve),
      meta: {
        title: '商户数据分布详情',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/serveDetail',
      name: 'adminServeDetail',
      component: resolve => require(['@/pages/admin/serveDetail'], resolve),
      meta: {
        title: '商户明细查询',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/reBuyDetail',
      name: 'adminReBuyDetail',
      component: resolve => require(['@/pages/admin/reBuyDetail'], resolve),
      meta: {
        title: '复购率详情',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/activeRateDetail',
      name: 'adminReBuyDetail',
      component: resolve => require(['@/pages/admin/activeRateDetail'], resolve),
      meta: {
        title: '活跃率详情',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/hhrDistribute',
      name: 'adminHhrDistribute',
      component: resolve => require(['@/pages/admin/hhrDistribute'], resolve),
      meta: {
        title: '合伙人分布详情',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/hhrList',
      name: 'adminHhrHhrList',
      component: resolve => require(['@/pages/admin/hhrList'], resolve),
      meta: {
        title: '合伙人列表',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/activeHhrList',
      name: 'adminActiveHhrList',
      component: resolve => require(['@/pages/admin/activeHhrList'], resolve),
      meta: {
        title: '本月活跃合伙人',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/orderMerchants',
      name: 'adminOrderMerchants',
      component: resolve => require(['@/pages/admin/orderMerchants'], resolve),
      meta: {
        title: '下单商户数',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/admin/orderNumber',
      name: 'adminOrderNumber',
      component: resolve => require(['@/pages/admin/orderNumber'], resolve),
      meta: {
        title: '子订单数量',
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/admin/serverList',
      name: 'adminServerList',
      component: resolve => require(['@/pages/admin/serverList'], resolve),
      meta: {
        title: '商家列表',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/pages/login'], resolve),
      meta: {
        title: '登录',
        auth: false
      }
    },
    {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: resolve => require(['@/pages/forgetPassword'], resolve),
      meta: {
        title: '忘记密码',
        auth: false
      }
    },
    {
      path: '/regist',
      name: 'regist',
      component: resolve => require(['@/pages/regist'], resolve),
      meta: {
        title: '成为合伙人',
        auth: false
      }
    },
    {
      path: '/registerAgreement',
      name: 'registerAgreement',
      component: resolve => require(['@/pages/agreement/register'], resolve),
      meta: {
        title: '合伙人服务协议',
        auth: false
      }
    },
    {
      path: '/registSuccess',
      name: 'registSuccess',
      component: resolve => require(['@/pages/registSuccess'], resolve),
      meta: {
        title: '成为合伙人',
        auth: false
      }
    },
    {
      path: '/protocal',
      name: 'protocal',
      component: resolve => require(['@/pages/protocal'], resolve),
      meta: {
        title: '注册协议',
        auth: false
      }
    },
    {
      path: '/serve',
      name: 'serve',
      component: resolve => require(['@/pages/serve/index'], resolve),
      meta: {
        title: '旗下商家',
        auth: true
      }
    },
    {
      path: '/order',
      name: 'order',
      component: resolve => require(['@/pages/order/index'], resolve),
      meta: {
        title: '订单管理',
        auth: true
      }
    },
    {
      path: '/order/detail/:orderno',
      name: 'orderDetail',
      component: resolve => require(['@/pages/order/detail'], resolve),
      meta: {
        title: '订单详情',
        auth: true
      }
    },
    {
      path: '/order/delivery',
      name: 'orderDelivery',
      component: resolve => require(['@/pages/order/delivery'], resolve),
      meta: {
        title: '查看物流',
        auth: true
      }
    },
    {
      path: '/purchaseOrder',
      name: 'purchaseOrder',
      component: resolve => require(['@/pages/purchaseOrder'], resolve),
      meta: {
        title: '进货订单管理',
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/purchaseOrder/returnOrder',
      name: 'purchaseOrderReturnOrder',
      component: resolve => require(['@/pages/purchaseOrder/returnOrder'], resolve),
      meta: {
        title: '退换货订单管理',
        auth: true
      }
    },
    {
      path: '/purchaseOrder/returnOrderDetail',
      name: 'purchaseOrderReturnOrderDetail',
      component: resolve => require(['@/pages/purchaseOrder/returnOrderDetail'], resolve),
      meta: {
        title: '退换货订单详情',
        auth: true
      }
    },
    {
      path: '/retailOrder',
      name: 'retailOrder',
      component: resolve => require(['@/pages/retailOrder'], resolve),
      meta: {
        title: '零售订单管理',
        auth: true
      }
    },
    {
      path: '/retailOrder/detail/:orderno',
      name: 'retailOrderDetail',
      component: resolve => require(['@/pages/retailOrder/detail'], resolve),
      meta: {
        title: '零售订单详情',
        auth: true
      }
    },
    {
      path: '/retailOrder/returnOrder',
      name: 'retailOrderReturnOrder',
      component: resolve => require(['@/pages/retailOrder/returnOrder'], resolve),
      meta: {
        title: '退换货订单管理',
        auth: true
      }
    },
    {
      path: '/retailOrder/returnOrderDetail',
      name: 'retailOrderReturnOrderDetail',
      component: resolve => require(['@/pages/retailOrder/returnOrderDetail'], resolve),
      meta: {
        title: '退换货订单详情',
        auth: true
      }
    },
    {
      path: '/user',
      name: 'serveUser',
      component: resolve => require(['@/pages/user'], resolve),
      meta: {
        title: '用户列表',
        auth: true
      }
    },
    {
      path: '/dataView',
      name: 'dataView',
      component: resolve => require(['@/pages/dataView/index'], resolve),
      meta: {
        title: '数据查询',
        auth: true
      }
    },
    {
      path: '/dataView/serve',
      name: 'dataViewServe',
      component: resolve => require(['@/pages/dataView/serve'], resolve),
      meta: {
        title: '按月数据查询',
        auth: true
      }
    },
    {
      path: '/dataView/order',
      name: 'dataViewOrder',
      component: resolve => require(['@/pages/dataView/order'], resolve),
      meta: {
        title: '订单总览',
        auth: true
      }
    },
    {
      path: '/dataExplain',
      name: 'dataExplain',
      component: resolve => require(['@/pages/dataExplain'], resolve),
      meta: {
        title: '数据说明',
        auth: true
      }
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: resolve => require(['@/pages/userCenter'], resolve),
      meta: {
        title: '个人中心',
        auth: true
      }
    },
    {
      path: '/userCenter/profile',
      name: 'userCenterProfile',
      component: resolve => require(['@/pages/userCenter/profile'], resolve),
      meta: {
        title: '个人资料',
        auth: true
      }
    },
    {
      path: '/userCenter/bonusDetail',
      name: 'bonusDetail',
      component: resolve => require(['@/pages/userCenter/bonusDetail'], resolve),
      meta: {
        title: '奖金详情',
        auth: true
      }
    },
    {
      path: '/userCenter/orderList',
      name: 'orderList',
      component: resolve => require(['@/pages/userCenter/orderList'], resolve),
      meta: {
        title: '订单列表',
        auth: true
      }
    },
    {
      path: '/userCenter/bonusFreezeList',
      name: 'bonusFreezeList',
      component: resolve => require(['@/pages/userCenter/bonusFreezeList'], resolve),
      meta: {
        title: '奖金冻结列表',
        auth: true
      }
    },
    {
      path: '/userCenter/bonusWithdraw',
      name: 'userCenterBonusWithdraw',
      component: resolve => require(['@/pages/userCenter/bonusWithdraw'], resolve),
      meta: {
        title: '提现',
        auth: true
      }
    },
    {
      path: '/userCenter/withdrawAccount',
      name: 'userCenterWithdrawAccount',
      component: resolve => require(['@/pages/userCenter/withdrawAccount'], resolve),
      meta: {
        title: '提现账户',
        auth: true
      }
    },
    {
      path: '/userCenter/bonusWithdrawRecord',
      name: 'userCenterBonusWithdrawRecord',
      component: resolve => require(['@/pages/userCenter/bonusWithdrawRecord'], resolve),
      meta: {
        title: '提现记录',
        auth: true
      }
    },
    {
      path: '/userCenter/editPassword',
      name: 'userCenterEditPassword',
      component: resolve => require(['@/pages/userCenter/editPassword'], resolve),
      meta: {
        title: '修改登陆密码',
        auth: true
      }
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: resolve => require(['@/pages/promotion'], resolve),
      meta: {
        title: '营销推广',
        auth: true
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: resolve => require(['@/pages/invite'], resolve),
      meta: {
        title: '邀请商家',
        auth: true
      }
    },
    {
      path: '/hhrList',
      name: 'hhrList',
      component: resolve => require(['@/pages/hhrList'], resolve),
      meta: {
        title: '旗下合伙人',
        auth: true
      }
    },
    {
      path: '/serveLevel',
      name: 'serveLevel',
      component: resolve => require(['@/pages/serveLevel'], resolve),
      meta: {
        title: '数据详情',
        auth: true
      }
    },
    {
      path: '/serveLevel/intro',
      name: 'serveLevelIntro',
      component: resolve => require(['@/pages/serveLevel/intro'], resolve),
      meta: {
        title: '分层说明',
        auth: true
      }
    },
    {
      path: '/mnCenter',
      name: 'mnCenter',
      component: resolve => require(['@/pages/mnCenter'], resolve),
      meta: {
        title: '赚钱专区',
        auth: true
      },
      children: [
        {
          path: 'product',
          name: 'product',
          component: resolve => require(['@/pages/mnCenter/product'], resolve),
          meta: {
            title: '赚钱专区',
          }
        },
        {
          path: 'jinhuo',
          name: 'jinhuo',
          component: resolve => require(['@/pages/mnCenter/jinhuo'], resolve),
          meta: {
            title: '赚钱专区',
          }
        },
      ]
    },
    {
      path: '/mnCenter/rewardExplain',
      name: 'mnCenterRewardExplain',
      component: resolve => require(['@/pages/mnCenter/rewardExplain'], resolve),
      meta: {
        title: '奖励政策说明',
        auth: true
      }
    },
    {
      path: '/accuratePromote',
      name: 'accuratePromote',
      component: resolve => require(['@/pages/accuratePromote'], resolve),
      meta: {
        title: '精准营销',
        auth: true
      }
    },
    {
      path: '/productDetail/:id',
      name: 'productDetail',
      component: resolve => require(['@/pages/product'], resolve),
      meta: {
        title: '商品详情',
        auth: true
      }
    },
    {
      path: '/agentList',
      name: 'agentList',
      component: resolve => require(['@/pages/agentList'], resolve),
      meta: {
        title: '代理商列表',
        auth: true
      }
    },
    {
      path: '/agentList/rewardExplain',
      name: 'agentListRewardExplain',
      component: resolve => require(['@/pages/agentList/rewardExplain'], resolve),
      meta: {
        title: '奖励政策',
        auth: true
      }
    },
    {
      path: '/agentList/qualify',
      name: 'agentListQualify',
      component: resolve => require(['@/pages/agentList/qualify'], resolve),
      meta: {
        title: '奖励达标情况',
        auth: true
      }
    },
    {
      path: '/agentList/dataByDate',
      name: 'agentListDataByDate',
      component: resolve => require(['@/pages/agentList/dataByDate'], resolve),
      meta: {
        title: '按月查询数据',
        auth: true
      }
    },
    {
      path: '/agentList/serveList',
      name: 'agentListServelist',
      component: resolve => require(['@/pages/agentList/serveList'], resolve),
      meta: {
        title: '商家列表',
        auth: true
      }
    },
    {
      path: '/orderedServer',
      name: 'orderedServer',
      component: resolve => require(['@/pages/home/orderedServer'], resolve),
      meta: {
        title: '下单商户情况',
        auth: true
      }
    },
    {
      path: '/unpayServer',
      name: 'unpayServer',
      component: resolve => require(['@/pages/home/unpayServer'], resolve),
      meta: {
        title: '待付款下单商户',
        auth: true
      }
    },
    {
      path: '/yearData',
      name: 'yearData',
      component: resolve => require(['@/pages/home/yearData'], resolve),
      meta: {
        title: '年度表现',
        auth: true
      }
    },
    {
      path: '/agentData',
      name: 'agentData',
      component: resolve => require(['@/pages/home/agentData'], resolve),
      meta: {
        title: '',
        auth: true
      }
    },
    {
      path: '/newCorp/corpList',
      name: 'corpList',
      component: resolve => require(['@/pages/newCorp/corpList'], resolve),
      meta: {
        title: '旗下合伙人',
        auth: true
      }
    },
    {
      path: '/newCorp/payServes',
      name: 'payServes',
      component: resolve => require(['@/pages/newCorp/payServes'], resolve),
      meta: {
        title: '缴费商家',
        auth: true
      }
    },
    {
      path: '/newCorp/unpayServes',
      name: 'unpayServes',
      component: resolve => require(['@/pages/newCorp/unpayServes'], resolve),
      meta: {
        title: '未缴费商家',
        auth: true
      }
    },
    {
      path: '/newCorp/servesbyCorp',
      name: 'servesbyCorp',
      component: resolve => require(['@/pages/newCorp/servesbyCorp'], resolve),
      meta: {
        title: '',
        auth: true
      }
    },
    {
      path: '/newChannel/serveList',
      name: 'newChannelServeList',
      component: resolve => require(['@/pages/newChannel/serveList'], resolve),
      meta: {
        title: '',
        auth: true,
        keepAlive: true
      }
    },
    {
      path: `/work`,
      name: 'work',
      component: resolve => require(['@/pages/work/index'], resolve),
      meta: {
        title: '工作',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/goodsResource',
      name: 'goodsResource',
      component: resolve => require(['@/pages/work/goodsResource'], resolve),
      meta: {
        title: '货品资源',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/reward',
      name: 'reward',
      component: resolve => require(['@/pages/work/reward'], resolve),
      meta: {
        title: '收益明细',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/purchaseReward',
      name: 'purchaseReward',
      component: resolve => require(['@/pages/work/purchaseReward'], resolve),
      meta: {
        title: '进货奖励',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/productA',
      name: 'productA',
      component: resolve => require(['@/pages/work/productA'], resolve),
      meta: {
        title: 'A级品奖励',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/basicPayReward',
      name: 'basicPayReward',
      component: resolve => require(['@/pages/work/basicPayReward'], resolve),
      meta: {
        title: '基础缴费奖励',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/scalePayReward',
      name: 'scalePayReward',
      component: resolve => require(['@/pages/work/scalePayReward'], resolve),
      meta: {
        title: '规模缴费奖励',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/orderList',
      name: 'orderList',
      component: resolve => require(['@/pages/work/orderList'], resolve),
      meta: {
        title: '订单列表',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/work/exportRecord',
      name: 'exportRecord',
      component: resolve => require(['@/pages/work/exportRecord'], resolve),
      meta: {
        title: '导出记录',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/ratingDetails',
      name: 'ratingDetails',
      component: resolve => require(['@/pages/newHome/ratingDetails'], resolve),
      meta: {
        title: '评级详情',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/matchMerchant',
      name: 'matchMerchant',
      component: resolve => require(['@/pages/increaseRevenue/matchMerchant'], resolve),
      meta: {
        title: '匹配商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/increaseRevenue/remarks',
      name: 'remarks',
      component: resolve => require(['@/pages/increaseRevenue/remarks'], resolve),
      meta: {
        title: '备注',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/rule',
      name: 'dataCenterRule',
      component: resolve => require(['@/pages/dataCenter/rule'], resolve),
      meta: {
        title: '政策规则',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/unpayUser',
      name: 'dataCenterUnpayUser',
      component: resolve => require(['@/pages/dataCenter/unpayUser'], resolve),
      meta: {
        title: '注册未缴费商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/recruitUser',
      name: 'dataCenterRecruitUser',
      component: resolve => require(['@/pages/dataCenter/recruitUser'], resolve),
      meta: {
        title: '缴费商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/gmvList',
      name: 'dataCenterGmvlist',
      component: resolve => require(['@/pages/dataCenter/gmvList'], resolve),
      meta: {
        title: '',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/gmv',
      name: 'gmv',
      component: resolve => require(['@/pages/dataCenter/gmvData'], resolve),
      meta: {
        title: 'GMV数据',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/recruitMerchant',
      name: 'recruitMerchant',
      component: resolve => require(['@/pages/dataCenter/recruitMerchant'], resolve),
      meta: {
        title: '招募商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataCenter/validLogin',
      name: 'validLogin',
      component: resolve => require(['@/pages/dataCenter/validLogin'], resolve),
      meta: {
        title: '有效登录商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/active',
      name: 'activePage',
      component: resolve => require(['@/pages/active/index'], resolve),
      meta: {
        title: '',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataDetail/activeUser',
      name: 'dataDetailActiveUser',
      component: resolve => require(['@/pages/dataDetail/activeUser'], resolve),
      meta: {
        title: '激活首单用户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataDetail/monthActiveUser',
      name: 'dataDetailMonthActiveUser',
      component: resolve => require(['@/pages/dataDetail/monthActiveUser'], resolve),
      meta: {
        title: '月活跃率符合标准商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/dataDetail/silenceActive',
      name: 'dataDetailSilenceActive',
      component: resolve => require(['@/pages/dataDetail/silenceActive'], resolve),
      meta: {
        title: '激活首单/沉默商户',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/realNameInfo',
      name: 'realNameInfo',
      component: resolve => require(['@/pages/userCenter/realNameInfo'], resolve),
      meta: {
        title: '实名信息',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/lableByPartnerDetail',
      name: 'lableByPartnerDetail',
      component: resolve => require(['@/pages/homeV2/lableByPartnerDetail'], resolve),
      meta: {
        title: '标签',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/completeStoreData',
      name: 'completeStoreData',
      component: resolve => require(['@/pages/homeV2/completeStoreData'], resolve),
      meta: {
        title: '完善店铺资料',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/unRegistUserProfile',
      name: 'unRegistUserProfile',
      component: resolve => require(['@/pages/homeV2/unRegistUserProfile'], resolve),
      meta: {
        title: '未注册商户资料',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/task25InfoUserList',
      name: 'task25InfoUserList',
      component: resolve => require(['@/pages/newHome/task25InfoUserList'], resolve),
      meta: {
        title: '',
        auth: true,
        keepAlive: false
      }
    },
    {
      path: '/workOrder',
      name: 'workOrder',
      component: resolve => require(['@/pages/workOrder/index'], resolve),
      meta: {
        title: '工单数据',
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/workOrder/detail',
      name: 'workOrderDetail',
      component: resolve => require(['@/pages/workOrder/detail'], resolve),
      meta: {
        title: '工单详情',
        auth: true,
        keepAlive: false
      }
    },
    // {
    //   path: '/workOrder/submit',
    //   name: 'workOrderSubmit',
    //   component: resolve => require(['@/pages/workOrder/submit'], resolve),
    //   meta: {
    //     title: '提交工单',
    //     auth: true,
    //     keepAlive: false
    //   }
    // },
    // {
    //   path: '/workOrder/installOrder',
    //   name: 'workOrderInstallOrder',
    //   component: resolve => require(['@/pages/workOrder/installOrder'], resolve),
    //   meta: {
    //     title: '报装订单',
    //     auth: true,
    //     keepAlive: false
    //   }
    // },
    // {
    //   path: '/workOrder/order',
    //   name: 'workOrderOrder',
    //   component: resolve => require(['@/pages/workOrder/order'], resolve),
    //   meta: {
    //     title: '选择订单',
    //     auth: true,
    //     keepAlive: false
    //   }
    // },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.auth) {
    let token = getSyncToken()
    if (token && isLogin()) {
      next()
    } else {
      document.title = '正在登陆...'
      store.commit('SET_LOGINGO', to.fullPath)
      router.push({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js